import { render, staticRenderFns } from "./Deactivate2fa.vue?vue&type=template&id=782c8516&"
import script from "./Deactivate2fa.vue?vue&type=script&lang=js&"
export * from "./Deactivate2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports